<template>
    <VJoyDropdown v-model="selectedSort" :options="sortOptions" class="appraisal-sort-menu__dropdown" width="180">
        <template #dropdown-button>
            <VJoyButton full variant="ghost" icon="sort" size="small" :label="currentSortLabel" class="appraisal-sort-menu__button" />
        </template>
    </VJoyDropdown>
</template>

<script setup lang="ts">
    import {computed, useTranslation} from '#imports';
    import {VJoyButton, VJoyDropdown} from '@maltjoy/core-vue';

    const {t} = useTranslation();

    const selectedSort = defineModel<AppraisalSortOption>('selected-sort', {default: 'most-relevant'});

    export type AppraisalSortOption = 'most-relevant' | 'best-rating' | 'most-recent';

    type SortOption = {
        id: AppraisalSortOption;
        label: string;
    };

    const sortOptions = computed<SortOption[]>(() => [
        {id: 'most-relevant', label: t('profile.section.appraisals.sort.most.relevant')},
        {id: 'best-rating', label: t('profile.section.appraisals.sort.best.rating')},
        {id: 'most-recent', label: t('profile.section.appraisals.sort.most.recent')},
    ]);

    const currentSortLabel = computed(() => {
        const option = sortOptions.value.find((opt: SortOption) => opt.id === selectedSort.value);
        return option?.label || t('profile.section.appraisals.sort.most.relevant');
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    :deep(.joy-dropdown__button) {
        width: 100%;
    }

    .appraisal-sort-menu__dropdown {
        width: 100%;

        @include joy.screen_xs(min) {
            width: auto;
        }
    }

    .appraisal-sort-menu__button {
        width: 100%;

        @include joy.screen_xs(min) {
            width: auto;
        }
    }
</style>
